export default __webpack_public_path__ + "static/3-men-de6df2548fef57f5a1953ab2d2e88cef.jpg";